import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  title: {
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginBlock: 4,
    marginLeft: 8
  },
  cellRow: {
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingBlock: 6
  },
  cellHead: {
    '&.MuiTableCell-head': {
      backgroundColor: 'grey',
      color: 'white'
    }
  },
  bodyStyle: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5'
    }
  },
  noCommissions: {
    color: 'red'
  }
}))

export default useStyles
